import { Typography, type TypographyProps } from '@mui/material';
import classNames from 'classnames';

import { Link, type GeneralLinkProps } from './link';

const typographyVariants: Record<
  'link' | 'tinyLink' | 'fileName',
  TypographyProps['variant']
> = {
  link: 'subtitle1',
  tinyLink: 'subtitle2',
  fileName: 'fileName',
};

export const TextLink = ({
  className,
  typographyVariant,
  ...props
}: GeneralLinkProps & {
  typographyVariant?: keyof typeof typographyVariants;
}) => {
  const linkClassName = classNames(
    'underline',
    {
      'text-(--mui-palette-text-disabled)': props.disabled,
      'text-(--mui-palette-text-primary) hover:text-(--mui-palette-text-secondary)':
        !props.disabled,
    },
    className
  );

  if (!typographyVariant) {
    return (
      <Link {...props} className={linkClassName}>
        {props.children}
      </Link>
    );
  }

  return (
    <Typography
      {...props}
      component={Link}
      variant={typographyVariants[typographyVariant]}
      className={linkClassName}
    >
      {props.children}
    </Typography>
  );
};
